import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { themeColors } from '../../config/themeSettings';

const galleryImages = [
  'https://static.businessworld.in/IMG_20251211_100720_20251211100901_original_image_27.webp',
  'https://static.businessworld.in/IMG_20251107_192034_20251211101005_original_image_44.webp',
  'https://static.businessworld.in/IMG-20251108-WA0045_20251211100928_original_image_36.webp',
  'https://static.businessworld.in/IMG_20251211_100801_20251211100914_original_image_5.webp',
  'https://static.businessworld.in/IMG_20251211_101524_20251211101557_original_image_32.webp',
  'https://static.businessworld.in/IMG_20251211_101502_20251211101550_original_image_4.webp',
  'https://static.businessworld.in/IMG_20251211_101423_20251211101542_original_image_32.webp',
];

const BwPoliceWorldArticle = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        December 10, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          'Say Help' app set to be implemented across Delhi with its success in just three months of arriving in India
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Box className={classes.carouselContainer}>
            <Carousel
              withIndicators
              height={400}
              slideSize="100%"
              slideGap="md"
              loop
              align="center"
              className={classes.carousel}>
              {galleryImages.map((image, index) => (
                <Carousel.Slide key={index}>
                  <Image
                    src={image}
                    alt={`Say Help App Gallery ${index + 1}`}
                    height={400}
                    fit="contain"
                  />
                </Carousel.Slide>
              ))}
            </Carousel>
          </Box>
          <div className={classes.imageAttribution}>
            Images from BW Police World
          </div>

          <Space h="xl" />

          <Box className={classes.subtitle}>
            <Text weight={600} size="lg">
              IPS Nidhin Valsan, currently posted as DCP Central in Delhi Police brought the globally known 'Say Help' app to India; the app works on voice recognition, camera and location all activated in a second to prompt police action
            </Text>
          </Box>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              <strong>New Delhi, December 10</strong>
            </Text>
            <Space h="md" />
            <Text>
              In distress? Then just speak to your phone and say 'help, help, help' thrice and within a few seconds the Delhi Police will arrive to help. The globally known 'Say Help' app has been brought to India by IPS Nidhin Valsan, currently posted as DCP Central in Delhi Police.
            </Text>
            <Space h="md" />
            <Text>
              The founder and developer of the app, Mahesh Salgaonkar is a US based businessman who started the app in US and South America that has aided thousands of citizens overseas.
            </Text>
            <Space h="md" />
            <Text>
              Since its inception in September this year, the 'Say Help' has been a successful project in central district aiding police in some crack downs.
            </Text>
            <Space h="md" />
            <Text>
              The 'Say Help' that began as a pilot project in central district of Delhi Police began has already garnered a lot of attention and citizens downloading the app for its interesting features.
            </Text>
            <Space h="md" />
            <Text>
              Know more about the story behind the development of this app, its journey to India and its functioning:
            </Text>
            <Space h="md" />
            <Box className={classes.videoContainer}>
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/ahXDb3QVsN8?si=sQBZIsbmq5NHvAXQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </Box>
            <Space h="md" />
            <Text>
              This is probably the first app in the country that has a voice enabled feature with camera working simultaneously to capture the photo of the accused giving precise location in record time to police to respond to emergencies and calls. With capturing of the photo of the accused, the police do not need to rely on CCTV cameras or hunt for his photo. The location of the victim not only reflects in the control room but also offers navigation to the police response team to ensure there is no delay in action.
            </Text>
            <Space h="md" />
            <Text>
              The control room gets around 40 calls a day from across the national capital. The calls are for enquiries and emergencies. 89% are reported to be enquiry calls.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Real Cases: Seven Big Cases Cracked
            </Title>
            <Space h="md" />
            <Text>
              The 'Say Help' app has barely started its journey in Delhi and has already got seven big cases cracking.
            </Text>
            <Space h="md" />
            <Text>
              It began with a case assigned at GB road when a group of journalism students who were in the area to make documentary were allegedly harassed by a group of men. The girls who had just learnt about the app downloaded it and used it. The police arrived in no time and rounded up the men on the spot.
            </Text>
            <Space h="md" />
            <Text>
              A senior citizen in central district received timely help during a fraud related intimidation case where the victims were helpless.
            </Text>
            <Space h="md" />
            <Text>
              This was followed by a domestic violence call from Noida where a woman called 'Say Help' and sought help. The Delhi Police then alerted Noida Police and, in less time, police reached to help rescue her.
            </Text>
            <Space h="md" />
            <Text>
              Similarly, a public dispute was resolved in north district where two groups began fighting with each other over a trivial matter.
            </Text>
            <Space h="md" />
            <Text>
              The 'Say Help' app even aided police to crack down on a human trafficking racket in Paharganj where a group of girls were trafficked and brought to a house secretly working as a brothel. Seven girls were rescued while a woman running that place was arrested.
            </Text>
            <Space h="md" />
            <Text>
              The most recent case is that of a girl living alone in Dwarka district where she was allegedly being harassed by house owner. She tried 112 many times but, in the end, she used 'Say Help' and got help. The landlord barged into her house after disconnecting electricity and began harassing the girl.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Advantages Over Traditional Methods
            </Title>
            <Space h="md" />
            <Text>
              The drawbacks of calling a police control room is the waiting time while inquiries from the beat constable sent to the spot and re verification of the address, number and issue for which the call is made. The biggest hurdle the caller or victim has to face is the loss of time while talking to control rooms while a crime can take place within seconds.
            </Text>
            <Space h="md" />
            <Text>
              However, with this app, which is boasting of the most advanced techniques, all one has to do is 'Say Help' and the camera, microphone and location is activated prompting the app control room.
            </Text>
            <Space h="md" />
            <Text>
              If help can reach by merely saying "help" then the citizens in any situation do not need to dial control rooms or police stations but use an app for the same.
            </Text>
            <Space h="md" />
            <Text>
              For crimes against women from stalking to eve teasing, harassment to abuse, and incidents of accidents, assault, public spats and the likes, the 'Say Help' app works in seconds.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Future Plans
            </Title>
            <Space h="md" />
            <Text>
              'Say Help' that is relatively new in the national capital, is geared up to be replicated across Delhi for its most advanced, usable and powerful mechanism. In coming days, the app can be used for even giving information to police for certain crime hotspots, narcotic syndicates and unusual activities in their areas.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor
              href="https://www.bwpoliceworld.com/author/ujjawala-sushil-nayudu"
              target="_blank">
              Ujjawala Sushil Nayudu
            </Anchor>
            . Source:{' '}
            <Anchor
              href="https://www.bwpoliceworld.com/article/say-help-app-set-to-beimplemented-across-delhi-with-it-s-success-in-just-three-months-of-arriving-in-india-583230"
              target="_blank">
              BW Police World
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default BwPoliceWorldArticle;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  carouselContainer: {
    width: '100%',
    marginTop: 20,
  },

  carousel: {
    '& .mantine-Carousel-indicator': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      '&[data-active]': {
        backgroundColor: themeColors.anchor,
      },
    },
  },

  videoContainer: {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%',
    marginTop: 10,
    marginBottom: 10,
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none',
      borderRadius: 8,
    },
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
    textAlign: 'center',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  subtitle: {
    fontFamily: 'Poppins',
    textAlign: 'center',
    color: themeColors.anchor,
    padding: '0 20px',
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
